module.exports = __webpack_public_path__ + "img/Frank.3a572b41.jpg";